export const UserPointExample =  ()=>{
    return (
        <div className="container">
            <h2>使い方</h2>
            ユーザーの勝敗やポイントを保存するテーブルです
        <p>デバッグ用ですここから直接は触らないでください</p>
            
        </div>
    )
}